import { Component, OnInit, Input } from '@angular/core';
import { Reservation } from '../../models/reservation';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { ReservationStore } from '../../service/reservation-store';
import { StaySummary } from '../../models/stay-summary';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { RoomStaySummary } from '../../models/room-stay-summary';
import { OnyxEvent } from '../../models/event';
import { ReservationUtils } from '../../utils/reservation-utils';

@Component({
  selector: 'pioneer-payment-reservations',
  templateUrl: './payment-reservations.component.html'
})
export class PaymentReservationsComponent implements OnInit {

  private onyxEvent: OnyxEvent;

  public reservations: Observable<List<Reservation>>;
  public staySummary: Observable<StaySummary>;

  constructor(private roomStore: ReservationStore) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {
    this.reservations = this.roomStore.getReservationListFilteredByStatus(ReservationStatusCode.CHECKED_OUT);
    this.staySummary = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
      .map((summary: RoomStaySummary) => {
        return summary.staySummary;
      });
  }

  getRevenue(reservation: Reservation): number {
    return ReservationUtils.getRevenue(reservation);
  }

  getCommission(reservation: Reservation): number {
    return ReservationUtils.getCommission(reservation, this.onyxEvent);
  }

  getCommissionFromStaySummary(staySummary: StaySummary): number {
    return staySummary.totalRevenue * this.onyxEvent.commissionRoomPercentage / 100;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/reservations/payment-reservations.component.ts